function formatExpirationDateString(expirationDate: string): string {
  const [year, month, day] = expirationDate.split('T')[0].split('-');
  const formattedDate = `${month}/${day}/${year}`;
  return ` ${formattedDate} 11:59 PM`;
}

export default {
  formatExpirationDateString,
};
